// Imports:

// Styles:
import 'bootstrap/scss/bootstrap.scss';

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss';

// Common libraries:
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Popper - neccessary for bootstrap
import Popper from 'popper.js/dist/umd/popper.js';
window.Popper = Popper;

import 'bootstrap';

import { TweenMax, TimelineMax, AttrPlugin, CSSPlugin, Bounce } from 'gsap/all';

const activated = [TweenMax, TimelineMax, AttrPlugin, CSSPlugin, Bounce];

import ScrollMagic from 'scrollmagic';
window.ScrollMagic = ScrollMagic;

import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js';

//import 'imports-loader?define=>false!gsap/src/minified/plugins/ScrollToPlugin.min.js';

/* Scroll Magic Scens Plugin */
import Scens from './plugins/PluginScrollmagicScens.js';

const controller = new ScrollMagic.Controller();

window.scens = new Scens(controller);

// Plugins
import './plugins/PluginLoadDependecies';
import './plugins/PluginLazyLoad';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import './plugins/outline.js';
import './plugins/jquery.nicescroll.js';
import popup from './plugins/PluginPopup';
window.popup = new popup();

import './plugins/PluginAnalytics';
import './plugins/PluginBlockEmbed';
import cookiesController from './plugins/PluginCookies';
// Create CookiesController instance
window.CookiesController = cookiesController;
window.CookiesController.fireActionEvent();

import LASingleLettersBreaker from './plugins/PluginLASingleLettersBreaker';

import converSVG from './plugins/converCSV.js';

window.svg = new converSVG();
window.svg.converSVG();

const select = document.querySelector("[data-type='select']");

if (select) {
  $("[data-type='select']").select2({
    minimumResultsForSearch: -1,
  });
}

// Components:
//

// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
let BwMenuPages = $("[data-item='BW-navigation-menu']");

// Check if menu exists
if (BwMenuPages.length > 0) {
  // Show/hide on button with menu icon
  $("[data-item='BW-navigation-button']").on('click', () => {
    if (BwMenuPages.length > 0) {
      // Check if menu is visible
      if (BwMenuPages.hasClass('visible') !== true) {
        // If true -> animate show
        BwMenuPages.addClass('visible');
        BwMenuPages.animate({ opacity: '1' }, 300);
      } else {
        // If false -> animate hide
        BwMenuPages.animate({ opacity: '0' }, 300, function () {
          BwMenuPages.removeClass('visible');
        });
      }
    }
  });

  // Hide on button 'X" click
  $("[data-action='BW-navigation-hide']").on('click', () => {
    if (BwMenuPages.length > 0) {
      // Animate hide
      BwMenuPages.animate({ opacity: '0' }, 300, function () {
        BwMenuPages.removeClass('visible');
      });
    }
  });
}

const header = document.querySelector('header');

// Remove preload class on load
window.addEventListener('load', () => {
  // if (!sessionStorage.getItem('mac-popup')) {

  //     let popupHandler = new popup();

  //     // init popup with score
  //     popupHandler.init('<div class="popup-content"><div class="popup-content__image"><img src="img/img-popup.png" alt="popup" /></div><div class="popup-content__text"><div class="text__iota weight__bold"><h2>'+popup_title+'Lorem ipsum dolor sit amet, consect adipisicing elit, sed do eiusmod tem</h2></div><div class="text__beta--alternative weight__light"><p>Lorem ipsum dolor sit amet, consect adipisicing elit. Lorem ipsum dolor sit amet, consect adipisicing elit, sed do eiusmod tem ipsum dolor sit amet, consect adipisicing elit, sed do eiusmod tem sed do eiusmod tem</p></div><div><a href="/" class="btn weight__bold text__theta text-uppercase color__omega" title="zobacz więcej">zobacz więcej</a></div></div></div><img src="img/close.png" class="close" data-popup-action="close" />', "popup--dwelling");
  // }

  // Check if there is hash in link, if true and section with such id exists, move page to top
  const linkHash = window.location.hash;
  if (linkHash) {
    // If there is hash, find right element
    const hashElement = document.getElementById(linkHash.split('#')[1]);
    if (hashElement) {
      // If there is such element, animate scroll to top
      $('html').animate(
        {
          scrollTop: 0,
        },
        10
      );
    }
  }

  setTimeout(function () {
    // Remove class that prevent transition
    const preload = document.querySelector('body');
    preload.classList.remove('preload');

    // hide loader
    let loader = document.querySelector("[data-item='loader']");
    let loaderStyle = document.querySelector("[data-item='loader-styles']");

    loader.parentNode.removeChild(loader);

    loaderStyle.parentNode.removeChild(loaderStyle);

    // #Animate scroll to section if there is anchor in url
    // Check if there is hash in link
    const linkHash = window.location.hash;
    if (linkHash) {
      // If there is hash, find right element
      const hashElement = document.getElementById(linkHash.split('#')[1]);
      if (hashElement) {
        // If there is such element, animate scroll to
        smoothScroll(hashElement, linkHash);
      }
    }

    // Add listener to all links that links to this page
    let currentUrl = window.location.pathname;
    let localLinks = document.querySelectorAll(`a[href*="${currentUrl}#"]`);
    if (localLinks.length > 0) {
      // If there are such links, handle smooth scroll on target elements
      localLinks.forEach((link) => {
        // Split hash from url
        let sectionID = link.getAttribute('href').split('#')[1];
        // Find right element
        const linkhashElement = document.getElementById(sectionID);
        if (linkhashElement) {
          // If there is such element, animate scroll to on click
          link.addEventListener('click', (e) => {
            e.preventDefault();
            smoothScroll(linkhashElement, linkHash);
          });
        }
      });
    }
    // document.querySelectorAll()

    // Function to animate smooth scroll to element
    function smoothScroll(element, hash) {
      let offset = -75;

      if (hash == '#offer') {
        offset = 150;
      }

      $('html').animate(
        {
          scrollTop: element.offsetTop + offset,
        },
        750
      );
    }
  }, 100);

  /* scroll magic scens */
  const about_us = document.querySelector('[data-item="about-us"]');
  const section_news_category = document.querySelector('[data-item="section-news-category"]');
  const section_news_item = document.querySelector('[data-item="section-news-item"]');
  const publications = document.querySelector('[data-item="publications"]');
  const contact = document.querySelector('[data-item="contact"]');
  const footer = document.querySelector('[data-item="footer"]');

  if (about_us) {
    window.scens.about_us();
  }

  if (section_news_category) {
    window.scens.section_news_category();
  }

  if (section_news_item) {
    window.scens.section_news_item();
  }

  if (publications) {
    window.scens.publications();
  }

  if (contact) {
    window.scens.contact();
  }

  if (footer) {
    window.scens.footer();
  }

  if (window.innerWidth <= 1200) {
    const pill = document.querySelectorAll("[data-toggle='pill']");

    pill.forEach((elem) => {
      elem.addEventListener('click', function (e) {
        $('html, body').animate(
          {
            scrollTop: $('.tab-content').offset().top - 80,
          },
          800
        );
      });
    });
  }

  if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
    header.classList.add('fixed');
  } else {
    header.classList.remove('fixed');
  }

  const leLettersBreaker = new LASingleLettersBreaker({
    autoInit: false,
    defaultSelector: 'body',
  });
});

window.addEventListener('scroll', function () {
  const show = header.querySelector('.show');

  // Get container with mobile menu for subpage career
  const mobileCareer = document.querySelector(`[data-item="career-menu-mobile"]`);

  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    header.classList.add('fixed');

    // Add class fixed, so header will be smaller on scroll
    mobileCareer ? mobileCareer.classList.add('fixed') : '';

    if (show) {
      show.classList.remove('show');
    }
  } else {
    header.classList.remove('fixed');

    // Remove class fixed, so header will be bigger if not scrolled
    mobileCareer ? mobileCareer.classList.remove('fixed') : '';
  }

  const dropdown_menu = document.querySelectorAll('.dropdown-menu.pinned');

  if (dropdown_menu) {
    dropdown_menu.forEach((menu) => {
      menu.classList.remove('pinned');
    });
  }
});
